import { render } from "./CIS-List-Landing.vue?vue&type=template&id=6d5f36a3&scoped=true"
import script from "./CIS-List-Landing.vue?vue&type=script&lang=js"
export * from "./CIS-List-Landing.vue?vue&type=script&lang=js"

import "./CIS-List-Landing.vue?vue&type=style&index=0&id=6d5f36a3&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d5f36a3"]])

export default __exports__